<ui-panel panelTitle="Form Built-In Banner">
  <p>
    This sample binds a form banner using <code>ez-form</code> inputs: <code>[bannerConfig]</code> and
    <code>[bannerMessage]</code>.
  </p>

  <div class="form-frame">
    <ui-form
      class="banner-form"
      [config]="formConfig"
      [containerClass]="'compact'"
      [bannerConfig]="bannerConfig()"
      [bannerMessage]="bannerMessage()"
      [(formValues)]="formValues"
    ></ui-form>

    <div class="flex gap-2 mt-2">
      <ui-button buttonText="Show Random Wisdom" (click)="showRandomWisdom($event)"></ui-button>
      <ui-button buttonText="Clear" [disabled]="!currentBanner().message" (click)="clearBanner()"></ui-button>
    </div>
  </div>

  <p>
    To create a custom banner type:
    choose a custom value (for example <code>calm</code>), then define a matching
    CSS class named <code>.ez-banner-calm</code> in your component or app styles.
  <br />
    This sample includes custom classes for <code>calm</code> and <code>legacy</code>
    in its SCSS file.
  </p>
</ui-panel>
